import React, { useContext, useState } from 'react';
import AppointmentList from '../../components/PatientAppointment/AppointmentList';
import { makeStyles } from '@material-ui/core';
import { Route, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { MainDialog, SubmitButton } from '../../components/UI';
import NewAppointment from '../../components/NewAppointment';
import { resetAppointmentEditRelatedStates } from '../../redux/Appointment/AppointmentAction';
import { useDispatch } from 'react-redux';
import MessagesContext from '../../contexts/messagesContext';
import { PlusIcon } from '../../components/UI/Icons';
import useCheckAccess from '../../hooks/useCheckAccess';
const styles = makeStyles({
    // container: {
    //     padding: '40px 56px 40px 52px',
    //     minHeight: '100%',
    //     backgroundColor: '#fff',
    //     borderRadius: '8px'
    // },
    appointmentList: {
        marginTop: '32px'
    },
    addButton: {
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            marginLeft: '8px'
        }
    },
    headerContainer: {
        padding: 16
    },
    plusSign: {
        // width: '22.2px',
        // height: '22.2px',
        // position: 'relative',
        margin: '9px 9px 0 9px',
        overflow: 'hidden'
    }
});
export default function Appointment() {
    const { messages } = useContext(MessagesContext);
    const [activeStep, setActiveStep] = useState(false);
    const classes = styles();
    const { url } = useRouteMatch();
    const handleGoBack = () => {
        setActiveStep(false);
        dispatch(resetAppointmentEditRelatedStates(null));
        history.push(url);
    };
    const dispatch = useDispatch();
    const { notEditDemographic } = useCheckAccess();
    const history = useHistory();
    const params = useParams();
    const stepper = [
        { name: messages.appointment, status: false },
        { name: messages.admission, status: true }
    ];
    const handleRedirectToNewAppointmentDialog = async () => {
        setActiveStep(false);
        await dispatch(resetAppointmentEditRelatedStates(null));
        history.push(`/${params.clinicId}/patient/${params.id}/appointments/new`);
    };

    return (
        <div>
            <div className={classes.headerContainer}>
                <SubmitButton
                    // variant="contained"
                    className={classes.addButton}
                    handleClick={handleRedirectToNewAppointmentDialog}
                    disabled={notEditDemographic}
                    disableSubmit
                >
                    <div className={classes.plusSign}>
                        <PlusIcon width="17px" height="17px" />
                    </div>
                    {messages.addNewAppointment}
                </SubmitButton>
                {!notEditDemographic && (
                    <Route
                        path={
                            params
                                ? `/${params.clinicId}/patient/${params.id}/appointments/new`
                                : `/${url}/new`
                        }
                        render={() => (
                            <MainDialog
                                open={true}
                                stepper={{ items: stepper, activeStep: activeStep }}
                                handleNavigation={(e) => setActiveStep(e)}
                                title=""
                                goBack={handleGoBack}
                            >
                                <NewAppointment
                                    activeStep={activeStep}
                                    setActiveStep={(state) => setActiveStep(state)}
                                    handleNavigation={(e) => setActiveStep(e)}
                                    patientId={params.id}
                                    closeModal={handleGoBack}
                                />
                            </MainDialog>
                        )}
                    />
                )}
            </div>
            <AppointmentList className={classes.appointmentList} />
        </div>
    );
}
